import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie } from 'lucide-react';
import {
  acceptCookies,
  hasDecidedConsent,
  rejectCookies,
} from '@/lib/consent/cookieConsent';

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!hasDecidedConsent()) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    acceptCookies();
    setVisible(false);
  };

  const handleReject = () => {
    rejectCookies();
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Consentimiento de cookies"
      className="fixed inset-x-0 bottom-0 z-[100] border-t border-border bg-background/95 p-4 shadow-lg backdrop-blur supports-[backdrop-filter]:bg-background/80"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden />
          <p className="text-sm text-muted-foreground">
            Usamos cookies y almacenamiento local para mantener tu sesión y medir el uso agregado del
            sitio. Podés aceptar la analítica o seguir solo con lo esencial.{' '}
            <Link to="/privacidad" className="font-medium text-primary underline underline-offset-2">
              Más información
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" size="sm" onClick={handleReject} data-testid="cookie-reject">
            Solo esencial
          </Button>
          <Button size="sm" onClick={handleAccept} data-testid="cookie-accept">
            Aceptar
          </Button>
        </div>
      </div>
    </div>
  );
}
